module.exports = __webpack_public_path__ + "e482b037e844aa25a445dc0b07ef4448.svg";